export const URL_VALIDATION =
  /^(?:wss|https?):\/\/(?!$|0\.0\.0\.0)(?:(?:(?:1?\d\d?|2[0-4]\d|25[0-5])(?:\.(?!$))?){4}|(?:[a-z\d]\.|[a-z\d](?:(?![-.]{2})[a-z\d-]){0,63}?[a-z\d]\.){1,63}?[a-z]{2,63})(?:[:/].*?)?$/gim;

export const EMAIL_VALIDATION =
  // eslint-disable-next-line no-control-regex
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export const ALPHANUMERIC_REGEXP = /^[0-9a-zA-Z]+$/;

export const FIELD_NAME_REGEXP = /^[a-zA-Z][a-zA-Z0-9_]*$/;

export const NO_SPACE_REGEXP = /^[^ ]+$/;

// example: "New Event @ 268.1584" -> "@ 268.1584"
export const TRAILING_AT_NUMBER_REGEXP = /(@\s*)(-?\d+(?:\.\d+)?)\s*$/;
